import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();

  const forwarded = location.state || {};
  const [email, setEmail] = useState(forwarded.email || "");
  const [otpValue, setOtpValue] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);
  const RESEND_SECONDS = 60;

  useEffect(() => {
    if (resendCountdown <= 0) return;
    const t = setInterval(() => setResendCountdown((c) => c - 1), 1000);
    return () => clearInterval(t);
  }, [resendCountdown]);

  useEffect(() => {
    if (email) setOtpSent(true);
  }, [email]);

  const handleSendOtp = async (emailToUse) => {
    try {
      setError("");
      setLoading(true);
      const emailPayload = emailToUse || email || "";
      if (!emailPayload || !emailPayload.includes("@")) {
        setError("Please enter a valid email to receive OTP");
        return;
      }
      setOtpSent(true);
      setEmail(emailPayload);
      setResendCountdown(RESEND_SECONDS);
    } catch (err) {
      console.error("Send OTP failed", err);
      const msg = err?.response?.data?.message || "Failed to send OTP";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = () => {
    if (resendCountdown > 0) return;
    handleSendOtp(email);
  };

  const handleVerifyOtp = async () => {
    try {
      setError("");
      setLoading(true);
      if (!email || !otpValue) {
        setError("Please provide both email and OTP");
        return;
      }
      navigate("/dashboard");
    } catch (err) {
      console.error("Verify OTP failed", err);
      setError(err?.response?.data?.message || "Failed to verify OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: "url(/images/login-bg.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="min-h-screen w-screen flex items-center justify-center px-4 py-16 font-sans"
    >
      <div className="max-w-md w-full backdrop-blur-sm bg-black/40 shadow-2xl transition-all duration-700 hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.5)] rounded-3xl p-8 border border-white/10 text-white">
        <h2 className="text-white text-center text-2xl font-bold mb-4">Verify OTP</h2>

        {error && <div className="text-sm text-red-300 mb-2">{error}</div>}

        <div className="mb-3">
          <label className="block text-white text-xs mb-1.5 ml-1">Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white/10 backdrop-blur-sm text-white placeholder-gray-400 rounded-xl py-2.5 px-3 border border-white/10 outline-none focus:ring-2 focus:ring-teal-400 text-sm"
            placeholder="you@example.com"
          />
        </div>

        <div className="mb-5">
          <label className="block text-white text-xs mb-1.5 ml-1">OTP</label>
          <input
            value={otpValue}
            onChange={(e) => setOtpValue(e.target.value)}
            className="w-full bg-white/10 backdrop-blur-sm text-white placeholder-gray-400 rounded-xl py-2.5 px-3 border border-white/10 outline-none focus:ring-2 focus:ring-teal-400 text-sm"
            placeholder="Enter OTP"
          />
        </div>

        <div className="items-center text-center">
          <button
            onClick={handleVerifyOtp}
            className="px-6 py-2.5 mr-3 bg-teal-600 hover:bg-teal-500 text-white font-semibold rounded-xl transition-all shadow-md"
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
          <button
            onClick={handleResendOtp}
            disabled={resendCountdown > 0}
            className="text-sm text-white/70 hover:underline disabled:opacity-50"
          >
            {resendCountdown > 0 ? `Resend in ${resendCountdown}s` : "Resend"}
          </button>
        </div>

        <div className="text-center mt-6">
          <Link to="/login" className="text-xs text-gray-400 hover:text-white transition-colors">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
